import { z } from "zod";

export const notificationPreferencesSchema = z.strictObject({
  inAppEnabled: z.boolean(),
  emailEnabled: z.boolean(),
  smsEnabled: z.boolean(),
  pushEnabled: z.boolean(),
  quietStartMinute: z.number().int().min(0).max(1439).nullable(),
  quietEndMinute: z.number().int().min(0).max(1439).nullable(),
  versionNo: z.number().int().min(1),
});

export const notificationPreferencesGetResponseSchema = z.strictObject({
  status: z.literal("ok"),
  preferences: notificationPreferencesSchema,
});

export const notificationPreferencesUpsertResponseSchema = z.strictObject({
  status: z.enum(["changed", "unchanged"]),
});

export type NotificationPreferences = z.infer<typeof notificationPreferencesSchema>;
